module.exports = __webpack_public_path__ + "files/9e3d88af9a7be2ed8b6c659e219e99f7.png";